import { gql } from 'graphql-request'

// Mutation query ("UserInput" is input defined in api)
export const SAVE_USER_INFO = gql`
  mutation saveUserInfo(
    $userInfo: UserInput!
    $communicationsData: [CommunicationsDataInput]!
  ) {
    saveUserInfo(userInfo: $userInfo)
    saveCommunicationsData(communicationsData: $communicationsData)
  }
`

// Mutation query ("PaymentExemptionInput" must be input defined in api)
export const SAVE_PAYMENT_EXEMPTION = gql`
  mutation savePaymentExemption($paymentExemption: PaymentExemptionInput!) {
    savePaymentExemption(paymentExemption: $paymentExemption)
  }
`

// Mutation query ("EmploymentsInput" must be input defined in api)
export const SAVE_EMPLOYMENTS_DATA = gql`
  mutation saveEmploymentsData($employmentsData: EmploymentsInput) {
    saveEmploymentsData(employmentsData: $employmentsData)
  }
`

// Mutation query ("MembershipCardInput" must be input defined in api)
export const SAVE_MEMBERSHIP_CARD = gql`
  mutation saveMembershipCard($membershipCard: MembershipCardInput!) {
    saveMembershipCard(membershipCard: $membershipCard)
  }
`
